export const REQUEST_USER_PROFILES = 'REQUEST_USER_PROFILES';
export const RECEIVE_USER_PROFILES = 'RECEIVE_USER_PROFILES';
export class RequestUserProfiles {
    constructor() {
        this.type = REQUEST_USER_PROFILES;
    }
}
export class ReceiveUserProfiles {
    constructor(invitedProfiles, activeProfiles, inactiveProfiles) {
        this.invitedProfiles = invitedProfiles;
        this.activeProfiles = activeProfiles;
        this.inactiveProfiles = inactiveProfiles;
        this.type = RECEIVE_USER_PROFILES;
    }
}
